<mat-card class="knso-card email-vendors-card">
    <mat-card-header>
        <div class="title">
            <p>Email Vendors</p>
            <button mat-icon-button (click)="closeDialog()"><mat-icon>close</mat-icon></button>
        </div>
    </mat-card-header>
    <mat-card-content>
       <form [formGroup]="form">
        <div>
            <p>Are you sure you want to email all vendors included in the payable batch?</p>
            <p>This email will include a detailed summary  of transactions and total HAP value. Please note, if the vendor does not have an email address on file, they will not receive a notification.</p>
        </div>
        <div class="email-vendors-input">
            <mat-form-field class="email-vendors-input-area"  appearance="outline">
                <mat-label>Custom Message</mat-label>
                <textarea matInput formControlName="customMessage" rows="4"></textarea>
            </mat-form-field>
        </div>
       </form>
    </mat-card-content>
    <mat-card-actions>
        <button mat-flat-button class="hds_button cancel" (click)="closeDialog()">Cancel</button>
        <button mat-flat-button class="hds_button" (click)="sendEmail()">Send</button>
    </mat-card-actions>
</mat-card>